import { useMemo } from "react";

import { ModuleStatus } from "src/clients/flow-api";
import { useWorkspaceContext } from "src/router/routerContextHooks";

export const useIsCaseManagementEnabled = (): {
  isEnabled: boolean;
} => {
  const { modules } = useWorkspaceContext();

  const isEnabled = useMemo(() => {
    if (!modules?.case_management) {
      return false;
    }

    const caseManagementModule = modules.case_management;
    return (
      caseManagementModule.status !== ModuleStatus.CREATE_IN_PROGRESS &&
      caseManagementModule.status !== ModuleStatus.CREATE_FAILED
    );
  }, [modules]);

  return {
    isEnabled,
  };
};
